import { QueryClient } from "@tanstack/react-query";
import { isApiError } from "@/api/errors";
import { STALE } from "@/api/queryKeys";

export function shouldRetry(failureCount: number, error: unknown): boolean {
  if (!isApiError(error)) return failureCount < 1;
  if (error.code === "NETWORK" || error.code === "RUNTIME_NOT_READY") return false;
  if (error.status >= 400 && error.status < 500) return false;
  return failureCount < 2;
}

export function createQueryClient(): QueryClient {
  const client = new QueryClient({
    defaultOptions: {
      queries: { retry: shouldRetry, refetchOnWindowFocus: true, staleTime: 10_000 },
      mutations: { retry: false },
    },
  });
  client.setQueryDefaults(["catalog"], { staleTime: STALE.catalog });
  client.setQueryDefaults(["profiles"], { staleTime: STALE.profiles });
  client.setQueryDefaults(["artifacts"], { staleTime: STALE.artifacts });
  client.setQueryDefaults(["runs"], { staleTime: STALE.runs });
  client.setQueryDefaults(["environment"], { staleTime: STALE.environment });
  client.setQueryDefaults(["me"], { staleTime: STALE.me });
  client.setQueryDefaults(["users"], { staleTime: STALE.users });
  client.setQueryDefaults(["stats"], { staleTime: STALE.stats });
  client.setQueryDefaults(["audit"], { staleTime: STALE.audit });
  return client;
}
